import {
  faCcAmex,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb,
  faCcMastercard,
  faCcVisa,
} from '@fortawesome/free-brands-svg-icons';
import { faCreditCardFront } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import type { ICreditCardSource } from '@feathr/blackbox';

import PaymentMethod from './PaymentMethod';

const BRAND_ICONS = {
  Visa: faCcVisa,
  MasterCard: faCcMastercard,
  'American Express': faCcAmex,
  'Diners Club': faCcDinersClub,
  Discover: faCcDiscover,
  JCB: faCcJcb,
  UnionPay: faCreditCardFront,
  Unknown: faCreditCardFront,
};

interface IProps {
  source: ICreditCardSource;
}

function CreditCard({ source }: IProps) {
  const icon = BRAND_ICONS[source.brand];
  return (
    <PaymentMethod
      icon={<FontAwesomeIcon icon={icon} size={'3x'} />}
      label={`Credit or Debit Card ending in ${source.last4}`}
    />
  );
}

export default CreditCard;
